import { Injectable } from '@angular/core';
import { INamedStringObject } from '../../../type_definitions/datatypes';

export interface IEditableTextOption extends INamedStringObject {
  id:'text' | 'title' | 'label' | 'info' | 'placeholder';
  key?:string;
}

export const ACSL_COMMENT_KEY:string = 'COMMENT_ACSL';
export const OTHERS_COMMENT_KEY:string = 'COMMENT';

export const CUSTOM_MENU_TEXT_ACSL_OTHERS:IEditableTextOption[] = [{
  id: 'text',
  name: 'Edit text for ACSL',
  key: ACSL_COMMENT_KEY
}, {
  id: 'text',
  name: 'Edit text for non-ACSL',
  key: OTHERS_COMMENT_KEY
}];

@Injectable()
export class EditableTextService {
  // construction of the full translation key
  public getFullKey(key:string, screen?:string, type?:string):string {
    let fullKey:string = '';
    if (screen) {
      fullKey += `${screen}.`;
    }

    fullKey += key;

    if (type) {
      fullKey += `.${type}`;
    }

    return fullKey.toUpperCase();
  }
}